import { render, staticRenderFns } from "./CourseData.vue?vue&type=template&id=322514b2&"
import script from "./CourseData.vue?vue&type=script&lang=js&"
export * from "./CourseData.vue?vue&type=script&lang=js&"
import style0 from "./CourseData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports